// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationCitationResponse } from './ConversationCitationResponse';
import {
    ConversationCitationResponseFromJSON,
    ConversationCitationResponseFromJSONTyped,
    ConversationCitationResponseToJSON,
    ConversationCitationResponseToJSONTyped,
} from './ConversationCitationResponse';

/**
 * 
 * @export
 * @interface ConversationMessageResponse
 */
export interface ConversationMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof ConversationMessageResponse
     */
    id: string;
    /**
     * 
     * @type {ConversationMessageResponseRoleEnum}
     * @memberof ConversationMessageResponse
     */
    role: ConversationMessageResponseRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationMessageResponse
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationMessageResponse
     */
    interactionId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ConversationMessageResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {Array<ConversationCitationResponse>}
     * @memberof ConversationMessageResponse
     */
    citations: Array<ConversationCitationResponse>;
}


/**
 * @export
 */
export const ConversationMessageResponseRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;
export type ConversationMessageResponseRoleEnum = typeof ConversationMessageResponseRoleEnum[keyof typeof ConversationMessageResponseRoleEnum];


/**
 * Check if a given object implements the ConversationMessageResponse interface.
 */
export function instanceOfConversationMessageResponse(value: object): value is ConversationMessageResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('interactionId' in value) || value['interactionId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('citations' in value) || value['citations'] === undefined) return false;
    return true;
}

export function ConversationMessageResponseFromJSON(json: any): ConversationMessageResponse {
    return ConversationMessageResponseFromJSONTyped(json, false);
}

export function ConversationMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'role': json['role'],
        'content': json['content'],
        'interactionId': json['interaction_id'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'citations': ((json['citations'] as Array<any>).map(ConversationCitationResponseFromJSON)),
    };
}

export function ConversationMessageResponseToJSON(json: any): ConversationMessageResponse {
    return ConversationMessageResponseToJSONTyped(json, false);
}

export function ConversationMessageResponseToJSONTyped(value?: ConversationMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'role': value['role'],
        'content': value['content'],
        'interaction_id': value['interactionId'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'citations': ((value['citations'] as Array<any>).map(ConversationCitationResponseToJSON)),
    };
}

